import script from "./SidebarGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarGroup.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarGroup.vue?vue&type=style&index=0&id=0ac8f426&lang=scss"

const __exports__ = script;

export default __exports__